import React from 'react';
import classNames from 'classnames';

interface RCListingGridProps {
  /** Children should all be `RCListingGrid.Item` instances. */
  children: React.ReactNode;

  /** This affects grid logic and may be deprecated once we roll a sidebar forward permanently. For now, if you're using an RCListingGrid inside an RCSiteWrapper with a sidebar, set it to true. */
  withSidebar?: boolean;

  /** This overrides our tiled grid & renders a single row instead. If you're using this, make sure to put it inside an `OverflowingRow`. */
  singleRow?: boolean;

  /** This will apply a pulse animation to the container; use if needed. */
  loading?: boolean;
}

/**
* Our main tiling component. Use this for rows or grids of listings. All children should be `RCListingGrid.Item` instances, but those are just empty boxes; you can render grids of listing cards, sell cards, whatever you need.
*/
export function RCListingGrid({
  singleRow = false,
  withSidebar,
  children,
  loading,
}: RCListingGridProps) {
  return (
    <ol className={classNames(
      'rc-listing-grid',
      { 'rc-listing-grid--loading': loading },
      { 'rc-listing-grid--single-row': singleRow },
      { 'rc-listing-grid--with-sidebar': withSidebar },
      { 'rc-listing-grid--without-sidebar': !withSidebar },
    )}>
      {children}
    </ol>
  );
}

interface GridItemProps {
  colSpan?: 'one' | 'all',
  children: React.ReactNode;
}

function ListingGridItem({
  colSpan = 'one',
  children,
}: GridItemProps) {
  return (
    <li className={classNames(
      'rc-listing-grid__item',
      { 'rc-listing-grid__item--span-all': colSpan === 'all' },
    )}>
      {children}
    </li>
  );
}

RCListingGrid.Item = ListingGridItem;
